import { createContext } from 'react'
export const TranslationContext = createContext({state: {}, actions: {}});